document.addEventListener('click', function (e) {
  window.dataLayer = window.dataLayer || [];

  // Header nav CTA "Cenová ponuka"
  if (e.target.closest('.menu__item--cta a[href="/pages/kontakt"]')) {
    window.dataLayer.push({ event: 'button_cenova_ponuka_clicked', cta_location: 'header_nav' });
  }

  // Fixed promo bar "Cenová ponuka"
  if (e.target.closest('.newsletter-bar__button[href="/pages/kontakt"]')) {
    window.dataLayer.push({ event: 'button_cenova_ponuka_clicked', cta_location: 'promo_bar' });
  }

  // "Otvoriť na mape" buttons in map sections
  if (e.target.closest('.banner.with-map a[href*="google.com/maps"]')) {
    window.dataLayer.push({ event: 'contact_map_link_clicked' });
  }
});
